import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    props: (route) => ({
      appArea: route.query.appArea || null,
      mapPage: route.query.mapPage || null,
      question: route.query.question || null,
      gista: route.query.gista || null
    })
  }
]

const router = new VueRouter({
  mode: 'hash', // Use hash mode for better compatibility
  routes
})

export default router
